// extracted by mini-css-extract-plugin
export default {"filter":"Z7QbgqzyO81CqOdxqdMg"};